import React from "react";
import { Modal, Button } from "./ui";
import Icon from "./Icon";

export default function ConfirmDialog({
  open, onClose, onConfirm, title = "Are you sure?", message,
  confirmLabel = "Delete", cancelLabel = "Keep it", tone = "coral",
  icon = "triangle-alert", busy = false, testid = "confirm-dialog",
}) {
  return (
    <Modal open={open} onClose={onClose} testid={testid}>
      <div className="text-center">
        <div className={`mx-auto w-16 h-16 rounded-full grid place-items-center mb-4 ${tone === "coral" ? "bg-coral/15 text-coral" : "bg-primary/15 text-primary"}`}>
          <Icon name={icon} width={30} height={30} />
        </div>
        <h3 className="font-heading font-black text-2xl text-ink mb-2">{title}</h3>
        {message && <p className="text-ink-soft font-medium mb-6">{message}</p>}
      </div>
      <div className="flex gap-3">
        <Button variant="outline" className="flex-1" onClick={onClose} disabled={busy} data-testid="confirm-cancel">{cancelLabel}</Button>
        <Button variant={tone === "coral" ? "coral" : "primary"} className="flex-1" onClick={onConfirm} disabled={busy} data-testid="confirm-ok">
          {busy ? "Working…" : confirmLabel}
        </Button>
      </div>
    </Modal>
  );
}
